import swal from './core.ts'
export default swal
